// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"6eb6f0784514db725620","5338":"26faf030a75ec4926056"}[chunkId] + ".js";
};